const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.admin.token,
  avatar: state => state.admin.avatar,
  name: state => state.admin.name,
  introduction: state => state.user.introduction,
  roles: state => state.admin.roles,
  adminInfo: state => state.admin.info,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  cartIds: state => state.product.cartIds,
  orderIds: state => state.order.orderIds
}
export default getters
